<form [formGroup]="fg" #form="ngForm">
    <section>
        <div class="group-section title-section">
            <h1 class="mat-headline-large">Living expenses</h1>
        </div>

        <div class="group-section">
            <p class="mat-body-large section-title">
                Please tell us your monthly living expenses for each of the following categories.
                <span class="section-subtitle">Only fill in the categories that apply to you.</span>
            </p>

            <!-- Power & utilities -->
            <div class="row">
                <div class="col-12">
                    <p class="flex-title">
                        <mat-icon svgIcon="bills"></mat-icon>Power & utilities
                    </p>
                    <div class="row">
                        <div class="col-7">
                            <app-form-field-currency [formSubmitted]="form.submitted" label="Amount"
                                [control]="fg.controls.billsUtilitiesExpense.controls.amount">
                            </app-form-field-currency>
                        </div>
                        <div class="col-5">
                            <app-form-field-select [control]="fg.controls.billsUtilitiesExpense.controls.frequency"
                                [listType]="SelectListType.FrequencyTypes" label="Frequency"></app-form-field-select>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Food -->
            <div class="row">
                <div class="col-12">
                    <p class="flex-title">
                        <mat-icon svgIcon="food"></mat-icon>Food & groceries
                    </p>
                    <div class="row">
                        <div class="col-7">
                            <app-form-field-currency [formSubmitted]="form.submitted" label="Amount"
                                [control]="fg.controls.foodGroceriesExpense.controls.amount">
                            </app-form-field-currency>
                        </div>
                        <div class="col-5">
                            <app-form-field-select [control]="fg.controls.foodGroceriesExpense.controls.frequency"
                                [listType]="SelectListType.FrequencyTypes" label="Frequency"></app-form-field-select>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Transport & vehicle costs -->
            <div class="row">
                <div class="col-12">
                    <p class="flex-title">
                        <mat-icon svgIcon="transport"></mat-icon>Transport & vehicle costs
                    </p>
                    <div class="row">
                        <div class="col-7">
                            <app-form-field-currency [formSubmitted]="form.submitted" label="Amount"
                                [control]="fg.controls.transportExpense.controls.amount">
                            </app-form-field-currency>
                        </div>
                        <div class="col-5">
                            <app-form-field-select [control]="fg.controls.transportExpense.controls.frequency"
                                [listType]="SelectListType.FrequencyTypes" label="Frequency"></app-form-field-select>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Phone, internet & streaming services -->
            <div class="row">
                <div class="col-12">
                    <p class="flex-title">
                        <mat-icon svgIcon="phone"></mat-icon>Phone, internet & streaming services
                    </p>
                    <div class="row">
                        <div class="col-7">
                            <app-form-field-currency [formSubmitted]="form.submitted" label="Amount"
                                [control]="fg.controls.phoneInternetExpense.controls.amount">
                            </app-form-field-currency>
                        </div>
                        <div class="col-5">
                            <app-form-field-select [control]="fg.controls.phoneInternetExpense.controls.frequency"
                                [listType]="SelectListType.FrequencyTypes" label="Frequency"></app-form-field-select>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Clothing, shoes & personal care -->
            <div class="row">
                <div class="col-12">
                     <p class="flex-title">
                        <mat-icon svgIcon="clothing"></mat-icon>Clothing, shoes & personal care
                    </p>
                    <div class="row">
                        <div class="col-7">
                            <app-form-field-currency [formSubmitted]="form.submitted" label="Amount"
                                [control]="fg.controls.clothingShoesPersonalCareExpense.controls.amount">
                            </app-form-field-currency>
                        </div>
                        <div class="col-5">
                            <app-form-field-select
                                [control]="fg.controls.clothingShoesPersonalCareExpense.controls.frequency"
                                [listType]="SelectListType.FrequencyTypes" label="Frequency"></app-form-field-select>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Insurances -->
            <div class="row">
                <div class="col-12">
                 <p class="flex-title">
                        <mat-icon svgIcon="insurance"></mat-icon>Insurances
                    </p>
                    <div class="row">
                        <div class="col-7">
                            <app-form-field-currency [formSubmitted]="form.submitted" label="Amount"
                                [control]="fg.controls.insuranceExpense.controls.amount">
                            </app-form-field-currency>
                        </div>
                        <div class="col-5">
                            <app-form-field-select [control]="fg.controls.insuranceExpense.controls.frequency"
                                [listType]="SelectListType.FrequencyTypes" label="Frequency"></app-form-field-select>
                        </div>
                    </div>
                </div>
            </div>



            <div class="group-section info-box">
                <div class="flex-content">
                    <div>
                        <div class="mat-title-medium black-font">Total monthly living expenses</div>
                    </div>
                    <div>
                        <span class="mat-headline-large">{{ totalLivingExpenses() | currency }}</span>
                    </div>
                </div>
            </div>

            <p class="mat-body-large">Occasionally, we may need to verify these expenses. In such cases, we'll ask you to provide bank statements for confirmation.
            </p>

            

             <div class="group-required">
                  <mat-slide-toggle [formControl]="fg.controls.understandsBankStatReq" hideIcon>I understand that I may
                need to supply bank statements to verify my living expenses</mat-slide-toggle>
                  <mat-error *ngIf="form.submitted && fg.controls.understandsBankStatReq.hasError('mustBeTrue')"
                    class="error-wrap">Please confirm that you understand the bank statement requirement.</mat-error>
                </div>

            

            <!-- TODO: check if v4 needs Other
                                <div
                                    *ngIf="expenseOther.controls.type && expenseOther.controls.type.value == ApplicationExpenseType.">
                                    <app-form-field [isMultiLine]="true" label="Description"
                                        [control]="expenseOther.controls.description"
                                        hint="Tell us more about this regular expense"></app-form-field>
                                </div> -->
        </div>

        <!-- Visible when no partner is on the application and the individual is married or in a de facto relationship -->
        <!-- 
        *ngIf="showExpenses && (parentFg.controls.step2.controls.maritalStatus.value == MaritalStatusEnum.Married || parentFg.controls.step2.controls.maritalStatus.value == MaritalStatusEnum.DeFacto) &&
             parentFg.controls.step2.controls.isPartnerOnApplication.value != UserAction.Yes && this.fg.controls.expensesSharedWithPartner.enabled"
         -->
        <div class="group-section"
            *ngIf="!this.vehicleAppService.isJointApplication() && 
                   !this.vehicleAppService.isCommericial() && 
                   this.vehicleAppService.isPrimaryIndividualMarried()">

            <app-form-button-group-simple [formSubmitted]="form.submitted"
                [control]="fg.controls.expensesSharedWithPartner"
                label="Do you share any of these living expenses with your spouse/partner?"
                errorPlaceholder="Please tell us whether you share any of these expenses with your spouse or partner.">
            </app-form-button-group-simple>

            <div class="group-section small-group"
                *ngIf=" fg.controls.expensesSharedWithPartner.value == UserAction.Yes">

                <p class="mat-body-large section-title">
                    What is your partner's take-home (after tax) income?
                    <span class="mat-body-large section-subtitle">Please account for any expected material changes to
                        your
                        income (if applicable)</span>
                </p>

                <div class="row">
                    <div class="col-12">
                        <div class="row">
                            <div class="col-7">
                                <app-form-field-currency [formSubmitted]="form.submitted" label="Amount"
                                    [control]="fg.controls.partnerNetIncome">
                                </app-form-field-currency>
                            </div>
                            <div class="col-5">
                                <app-form-field-select [control]="fg.controls.partnerNetIncomeFrequency"
                                    [listType]="SelectListType.FrequencyTypes"
                                    label="Frequency"></app-form-field-select>
                            </div>
                        </div>
                    </div>
                </div>

            </div>


        </div>

        <!--  showExpenses && !partnerFg && 
            (parentFg.controls.step2.controls.maritalStatus.value == MaritalStatusEnum.Married || parentFg.controls.step2.controls.maritalStatus.value == MaritalStatusEnum.DeFacto) &&
            fg.controls.expensesSharedWithPartner.value == UserAction.Yes  && this.fg.controls.expensesSharedWithPartner.enabled -->



        <div>
            <hr class="separator no-margin-top">
            <section>
                <div class="group-section">
                    <h1 class="mat-headline-large">Other expenses</h1>
                </div>
                <div class="group-section">
                    <div class="group-section">
                        <app-form-button-group-simple [formSubmitted]="form.submitted"
                            [control]="fg.controls.hasOtherExpenses"
                            label="Do you have any of the following regular expenses?"
                            errorPlaceholder="Please tell us whether you have any of these regular expenses."
                            hint="Rates, childcare, school fees, medical costs, child support, tithing/donations">
                        </app-form-button-group-simple>
                    </div>
                </div>

                <ng-container *ngIf="fg.controls.otherExpenses && fg.controls.hasOtherExpenses.value == UserAction.Yes"
                    class="section-spacing">
                    <ng-container *ngFor="let expenseOther of fg.controls.otherExpenses.controls; let i = index">
                        <div class="group-section small-group">
                            <span
                                *ngIf="expenseOther.controls.type.disabled && expenseOther.controls.type.value == PublicPaymentDetailApplicationExpenseType.Rates"
                                class="green-text">
                                We've automatically added rates as an expense as you indicated previously you are a
                                homeowner.
                            </span>

                            <div class="row">
                                <div class="col-12">
                                    <div class="flex-content height-24">
                                        <p class="mat-body-large">Other expense {{i+1}}</p>
                                        <button mat-button class="link-button no-background-link remove" type="button"
                                            *ngIf="!expenseOther.controls.type.disabled"
                                            (click)="removeExpense(i)"><mat-icon
                                                svgIcon="trash"></mat-icon>Remove</button>
                                    </div>
                                </div>
                            </div>
                            <div class="group-section">
                                <app-form-field-select [control]="expenseOther.controls.type"
                                    [listType]="SelectListType.ExpenseTypesV4"
                                    label="Expense type"></app-form-field-select>

                                <div class="row">
                                    <div class="col-12">
                                        <div class="row">
                                            <div class="col-7">
                                                <app-form-field-currency [formSubmitted]="form.submitted" label="Amount"
                                                    [control]="expenseOther.controls.amount">
                                                </app-form-field-currency>
                                            </div>
                                            <div class="col-5">
                                                <app-form-field-select [control]="expenseOther.controls.frequency"
                                                    [listType]="SelectListType.FrequencyTypes"
                                                    label="Frequency"></app-form-field-select>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <!-- TODO: check if v4 needs Other
                                <div
                                    *ngIf="expenseOther.controls.type && expenseOther.controls.type.value == ApplicationExpenseType.">
                                    <app-form-field [isMultiLine]="true" label="Description"
                                        [control]="expenseOther.controls.description"
                                        hint="Tell us more about this regular expense"></app-form-field>
                                </div> -->
                            </div>
                        </div>
                    </ng-container>
                    <div *ngIf="fg.controls.hasOtherExpenses.value == UserAction.Yes" class="height-24">
                        <button mat-button class="link-button no-background-link" (click)="addExpense()"
                            type="button"><mat-icon svgIcon="add"></mat-icon>Add
                            another</button>
                    </div>

                    <div class="group-section info-box remove-margin-top">
                        <div class="flex-content">
                            <div>
                                <div class="mat-title-medium black-font">Total monthly other expenses</div>
                            </div>
                            <div>
                                <span class="mat-headline-large">{{ totalOtherExpenses() | currency }}</span>
                            </div>
                        </div>
                    </div>

                </ng-container>
            </section>
        </div>

        <div class="group-section">
            <button class="btn-next" mat-flat-button (click)="onButtonNext(fg, parentStepper)">Next</button>
        </div>
    </section>



</form>